<template>
    <h1>validacion de credenciales</h1>
</template>
<script>
export default {
    name: 'ValCredential'
}
</script>